export const showMenuPages = [
  "INTEGRATIONS_PAGE",
  "AGGREGATIONS_PAGE",
  "CVES_PAGE",
  "TOP_COMMON_ISSUES_PAGE",
  "RESOURCES_PAGE",
  "TAGS_PAGE",
  "TOTAL_AUTOMATIONS_PAGE",
  "TOP_ASSIGNEES_PAGE",
  "TOP_QUEUES_PAGE",
  "ACCOMPLISHMENTS_PAGE",
  "NO_QUEUES_PAGE",
];
export const pagesPerMenuItem = {
  Integration: ["INTEGRATIONS_PAGE"],
  Findings: ["AGGREGATIONS_PAGE", "CVES_PAGE", "TOP_COMMON_ISSUES_PAGE"],
  Resources: ["RESOURCES_PAGE", "TAGS_PAGE"],
  Automations: [
    "TOTAL_AUTOMATIONS_PAGE",
    "TOP_ASSIGNEES_PAGE",
    "TOP_QUEUES_PAGE",
    "NO_QUEUES_PAGE",
  ],
  Accomplishments: ["ACCOMPLISHMENTS_PAGE"],
};
export const getFirstMenuItemPageIndex = (
  pages: string[],
  menuItem: string
) => {
  switch (menuItem) {
    case "Integration":
      return pages.findIndex(
        (key: string) => key === pagesPerMenuItem.Integration[0]
      );
    case "Findings":
      if (
        pages.findIndex(
          (key: string) => key === pagesPerMenuItem.Findings[0]
        ) === -1
      ) {
        return pages.findIndex(
          (key: string) => key === pagesPerMenuItem.Findings[1]
        );
      }
      return pages.findIndex(
        (key: string) => key === pagesPerMenuItem.Findings[0]
      );
    case "Automations":
      if (
        pages.findIndex(
          (key: string) => key === pagesPerMenuItem.Automations[0]
        ) === -1
      ) {
        if (
          pages.findIndex(
            (key: string) => key === pagesPerMenuItem.Automations[1]
          ) === -1
        ) {
          if (
            pages.findIndex(
              (key: string) => key === pagesPerMenuItem.Automations[2]
            ) === -1
          ) {
            return pages.findIndex(
              (key: string) => key === pagesPerMenuItem.Automations[3]
            );
          }
          return pages.findIndex(
            (key: string) => key === pagesPerMenuItem.Automations[2]
          );
        }
        return pages.findIndex(
          (key: string) => key === pagesPerMenuItem.Automations[1]
        );
      }
      return pages.findIndex(
        (key: string) => key === pagesPerMenuItem.Automations[0]
      );
    case "Resources":
      return pages.findIndex(
        (key: string) => key === pagesPerMenuItem.Resources[0]
      );
    case "Accomplishments":
      return pages.findIndex(
        (key: string) => key === pagesPerMenuItem.Accomplishments[0]
      );
    default:
      return 0;
  }
};
export const slidesOrder = [
  "INTRO_PAGE",
  "INTEGRATIONS_PAGE",
  "AGGREGATIONS_PAGE",
  "CVES_PAGE",
  "TOP_COMMON_ISSUES_PAGE",
  "RESOURCES_PAGE",
  "TAGS_PAGE",
  "TOTAL_AUTOMATIONS_PAGE",
  "TOP_ASSIGNEES_PAGE",
  "TOP_QUEUES_PAGE",
  "NO_QUEUES_PAGE",
  "ACCOMPLISHMENTS_PAGE",
  "FINAL_PAGE",
];
